// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"CharacterSheetCastingAddPower_checkbox_3xfs6"};